import './input.css'

const InputSearch = ({ name, value, placeholder, error, onChange }) => {

  const handleChange = (e) => {

    const { value } = e.target
    onChange(value)

  }
 

  return (
    
      <input
        type='text'
        name={name}
        className={error ? ' errorfocus' :''}
        autoComplete='off'
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        required
      />
  )
}
export default InputSearch